import React from "react";

const CancellationRefundPolicy = () => {
  return (
<div className="w-full bg-gray-500" style={{ padding: "40px" }}> 
<div className="mx-auto px-8 sm:px-12 md:px-16 lg:px-24" > 
          <h1 className="text-3xl font-bold">CANCELLATION AND REFUND POLICY</h1>

        <p>
          This Cancellation and Refund Policy ("Policy") applies to all insurance services provided through our portal ("Website") available at <a href="https://www.finrelinsure.com" className="underline text-blue-600">https://www.finrelinsure.com</a>, operated by <strong>Finreliable Technology IMF Private Limited</strong>, doing business as <strong>Finreliable Technology IMF</strong> ("we", "us", or "our"). By using our services, you ("User", "you", or "your") agree to be bound by the terms of this Policy in addition to our other policies and Terms & Conditions.
        </p>

        <h2 className="text-2xl font-semibold mt-8">1. GENERAL PROVISIONS</h2>

        <p className="font-semibold">Scope:</p>
        <p>
          This Policy governs the cancellation of service requests, account terminations, and refund processes related to insurance services (such as car insurance, bike insurance, health insurance, travel insurance, home insurance, etc.), and related features provided on our website. Specific service offerings may have additional terms; these will be communicated during enrollment or service activation.
        </p>

        <p className="font-semibold">Acceptance:</p>
        <p>By availing our insurance services, you acknowledge that you have read, understood, and agreed to this Cancellation and Refund Policy.</p>

        <h2 className="text-2xl font-semibold mt-8">2. CANCELLATION BY THE USER</h2>

        <p className="font-semibold">2.1 Cancellation Before Service Activation</p>
        <p><strong>Full Refund Eligibility:</strong> If you decide to cancel your insurance service before your account is activated or before any transactions are processed, you may be eligible for a full refund, subject to the following conditions:</p>
        <ul className="list-disc list-inside space-y-2 ml-4">
          <li>A cancellation request must be submitted in writing through your account dashboard or by emailing <a href="mailto:support@finreliable.com" className="underline text-blue-600">support@finreliable.com</a>.</li>
          <li>The cancellation request must be received at least seven days prior to the scheduled service activation or before your first transaction, as specified during enrollment.</li>
        </ul>

        <p className="font-semibold">2.2 Cancellation After Service Activation</p>
        <ul className="list-disc list-inside space-y-2 ml-4">
          <li><strong>Partial/Pro-Rata Refund:</strong> Refund will not be calculated on a pro-rata basis after your account is activated or transactions are processed.</li>
          <li><strong>No Refund Scenario:</strong> No refund will be available if you cancel after the insurance premium has been paid.</li>
        </ul>

        <p className="font-semibold">2.3 Cancellation Request Process</p>
        <ul className="list-disc list-inside space-y-2 ml-4">
          <li><strong>Submission:</strong> Log in to your account and submit a cancellation request via "My Account" or "Support", or email <a href="mailto:support@finreliable.com" className="underline text-blue-600">support@finreliable.com</a>.</li>
          <li><strong>Acknowledgment and Processing:</strong> Requests are reviewed and acknowledged within 7 business days. Refunds (if applicable) are processed via your original payment method within 14–30 days.</li>
        </ul>

        <h2 className="text-2xl font-semibold mt-8">3. CANCELLATION INITIATED BY FinReliable Technology IMF</h2>

        <p className="font-semibold">3.1 Service Cancellation by FinReliable Technology IMF</p>
        <ul className="list-disc list-inside space-y-2 ml-4">
          <li><strong>Circumstances:</strong> Technical failures, regulatory changes, or unforeseen issues may cause suspension or termination of services.</li>
          <li><strong>Full Refund:</strong> If services are canceled or significantly altered adversely affecting your experience, you are entitled to a full refund for the affected period.</li>
          <li><strong>Notification:</strong> You will be notified via email and the Website regarding any cancellation or service interruption along with instructions for the refund.</li>
        </ul>

        <p className="font-semibold">3.2 Instructor or Third-Party Service Issues:</p>
        <p>Although services are primarily automated, if third-party platforms experience disruptions, we may offer rescheduling or a refund at our discretion.</p>

        <h2 className="text-2xl font-semibold mt-8">4. NON-REFUNDABLE FEES</h2>
        <ul className="list-disc list-inside space-y-2 ml-4">
          <li><strong>Administrative Fees:</strong> Account setup or service transaction fees may be non-refundable.</li>
          <li><strong>Deductible Charges:</strong> Portions of fees corresponding to services already delivered or irreversible transactions may be deducted from the refund.</li>
        </ul>

        <h2 className="text-2xl font-semibold mt-8">5. SPECIAL CASES</h2>
        <ul className="list-disc list-inside space-y-2 ml-4">
          <li><strong>Promotional Offers and Discounts:</strong> Refunds are based on the actual amount paid after any promotions or discounts.</li>
          <li><strong>Subscription-Based Services:</strong> Cancellation for subscription services is handled on a billing-cycle basis. No refund is provided for periods already utilized.</li>
        </ul>

        <h2 className="text-2xl font-semibold mt-8">6. DISPUTE RESOLUTION</h2>
        <p>
          Contact our customer support at <a href="mailto:support@finreliable.com" className="underline text-blue-600">support@finreliable.com</a>. If unresolved, disputes will follow procedures outlined in our Terms & Conditions.
        </p>

        <h2 className="text-2xl font-semibold mt-8">7. CHANGES TO THIS POLICY</h2>
        <p>
          We reserve the right to update or modify this Policy. Changes are posted on the Website, and registered users will be notified prior to changes taking effect. Continued use of services constitutes acceptance of updated terms.
        </p>

        <h2 className="text-2xl font-semibold mt-8">8. CONTACT US</h2>
        <p>
          For questions or clarification, contact us at <a href="mailto:support@finreliable.com" className="underline text-blue-600">support@finreliable.com</a>.
        </p>
      </div>
    </div>
  );
};

export default CancellationRefundPolicy;
